import CircularProgress from "@mui/material/CircularProgress";
const Loader = () => (
  <div className="loader">
    <CircularProgress size={100} />
  </div>
);

export default Loader;
